<!-- Header -->
<app-landingpage-header-child></app-landingpage-header-child>

<!-- Main -->
<div>
    <router-outlet></router-outlet>
</div>

<!-- Footer -->
<app-landingpage-footer></app-landingpage-footer>
